import React from "react";
import { motion } from "framer-motion";
import { PALETTE } from "../../lib/colorPallete";
import { IProduct } from "../../types/types";

interface ProductHeaderProps {
  product: IProduct;
}

export const ProductHeader: React.FC<ProductHeaderProps> = ({ product }) => {
  return (
    <div className="p-4 border-b border-stone-200 shrink-0">
      <motion.h3
        layoutId={`name-${product._id}`}
        className="font-serif text-xl font-bold"
        style={{ color: PALETTE.darkGreen }}
      >
        {product.modelName}
      </motion.h3>
      <motion.p
        layoutId={`subtext-${product._id}`}
        className="mt-1 text-sm leading-snug"
        style={{ color: `${PALETTE.darkGreen}B3` }}
      >
        {product.subtext}
      </motion.p>
    </div>
  );
};
